import { render, staticRenderFns } from "./Shared.vue?vue&type=template&id=52ed72de&scoped=true"
import script from "./Shared.vue?vue&type=script&lang=js"
export * from "./Shared.vue?vue&type=script&lang=js"
import style0 from "./Shared.vue?vue&type=style&index=0&id=52ed72de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed72de",
  null
  
)

export default component.exports